import { Star } from "lucide-react";
import { useContent } from "@/context/ContentContext";

export default function Reviews() {
  const { content } = useContent();
  const reviews = content.reviews || [];
  const avg =
    reviews.length > 0
      ? reviews.reduce((a, r) => a + Number(r.rating || 5), 0) / reviews.length
      : 0;

  if (reviews.length === 0) return null;

  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="py-20 md:py-28 bg-[#FAF7F2]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <p className="overline">Guest stories</p>
            <h2
              data-testid="reviews-title"
              className="font-serif-display text-4xl md:text-5xl mt-3 text-[#232E26]"
            >
              Loved by{" "}
              <em className="not-italic text-[#C65D47]">
                families and couples.
              </em>
            </h2>
          </div>
          <div
            data-testid="reviews-average"
            className="flex items-center gap-3 text-[#232E26]"
          >
            <div className="flex">
              {[0, 1, 2, 3, 4].map((i) => (
                <Star
                  key={i}
                  size={18}
                  className="fill-[#C65D47] text-[#C65D47]"
                />
              ))}
            </div>
            <span className="font-serif-display text-2xl">{avg.toFixed(1)}</span>
            <span className="text-[#5B6E4A] text-sm">
              · {reviews.length} reviews
            </span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {reviews.map((r, i) => (
            <article
              key={i}
              data-testid={`review-${i}`}
              className="bg-white border border-[#EAE0D5] p-8 md:p-10 relative"
            >
              <div className="flex items-center gap-2 mb-5">
                {Array.from({ length: Number(r.rating) || 5 }).map((_, k) => (
                  <Star
                    key={k}
                    size={14}
                    className="fill-[#C65D47] text-[#C65D47]"
                  />
                ))}
              </div>
              <p className="font-serif-display text-xl md:text-2xl leading-[1.4] text-[#232E26]">
                &ldquo;{r.body}&rdquo;
              </p>
              <div className="mt-6 flex items-center justify-between">
                <div>
                  <p className="text-[#232E26] font-medium">{r.name}</p>
                  <p className="text-[#5B6E4A] text-sm">{r.country}</p>
                </div>
                <p className="text-[#5B6E4A] text-xs tracking-[0.2em] uppercase">
                  {r.stay}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
